module.exports = __webpack_public_path__ + "img/227-scotland.4a1b3290.svg";